import { ChartClient } from '@frontend/chart/api';
import { IotsVolumeByTypeListChart } from '@frontend/chart/components';
import { Chart } from '@frontend/chart/types';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useInsightFetchRange } from '../../../analytics/insights/insight-detail/use-insight-fetch-range';
import { HardwareIotsVolumeByTypeListChartProps } from './hardware-iots-volume-by-type-list-chart.component';

const getEntityOnlyChartRange = () => ({ after: '', before: '' });

export const useHardwareIotsVolumeByTypeListChart = (props: HardwareIotsVolumeByTypeListChartProps) => {
    const navigate = useNavigate();
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    const fetchRange = useInsightFetchRange(getEntityOnlyChartRange);

    useEffect(() => {
        if (!props.accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        ChartClient.fetchChartData(props.accountId, IotsVolumeByTypeListChart.definition, {
            ...fetchRange.entityParams
        })
            .then((chart) => {
                if (!cancelled) {
                    setData(chart);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.accountId, fetchRange.key]);

    const navigateToType = (type?: string) => {
        if (!type) {
            navigate('/hardware/infrastructure');
            return;
        }
        navigate(`/hardware/infrastructure?type=${encodeURIComponent(type)}`);
    };

    return { data, isLoading, navigateToType };
};
